import {
  LEGACY_MERCHANT_FULL_ACCESS_PRIVILEGE,
  ROUTE_PRIVILEGES_FINANCE_AND_RETURNS,
  ROUTE_PRIVILEGES_INTEGRATION,
  ROUTE_PRIVILEGES_ORDERS,
  ROUTE_PRIVILEGES_SALES_CHANNELS,
  ROUTE_PRIVILEGES_USERS,
} from '@core/constants/merchant-route-privileges';
import type { MerchantUserPrivilege } from '@core/api/model/merchantUserPrivilege';

export interface AuthenticatedRouteOption {
  path: string;
  requiredPrivileges: readonly MerchantUserPrivilege[];
}

/** Menu-order landing targets for post-login and root redirects. */
export const AUTHENTICATED_ROUTE_OPTIONS: readonly AuthenticatedRouteOption[] = [
  { path: '/orders', requiredPrivileges: ROUTE_PRIVILEGES_ORDERS },
  { path: '/returns', requiredPrivileges: ROUTE_PRIVILEGES_FINANCE_AND_RETURNS },
  { path: '/settlements', requiredPrivileges: ROUTE_PRIVILEGES_FINANCE_AND_RETURNS },
  { path: '/invoices', requiredPrivileges: ROUTE_PRIVILEGES_FINANCE_AND_RETURNS },
  { path: '/wallets', requiredPrivileges: ROUTE_PRIVILEGES_FINANCE_AND_RETURNS },
  { path: '/sales-channels', requiredPrivileges: ROUTE_PRIVILEGES_SALES_CHANNELS },
  { path: '/products', requiredPrivileges: ROUTE_PRIVILEGES_FINANCE_AND_RETURNS },
  { path: '/users', requiredPrivileges: ROUTE_PRIVILEGES_USERS },
  { path: '/integration-profiles-logs', requiredPrivileges: ROUTE_PRIVILEGES_INTEGRATION },
] as const;

const FALLBACK_AUTHENTICATED_ROUTE = '/settings';

export function satisfiesAnyRoutePrivilegeForUser(
  userPrivileges: readonly string[],
  required: readonly MerchantUserPrivilege[],
): boolean {
  if (required.length === 0) {
    return true;
  }
  if (userPrivileges.includes(LEGACY_MERCHANT_FULL_ACCESS_PRIVILEGE)) {
    return true;
  }
  return required.some((privilege) => userPrivileges.includes(privilege));
}

export function getDefaultAuthenticatedRoute(
  userPrivileges: readonly MerchantUserPrivilege[],
): string {
  const userPrivs = userPrivileges as readonly string[];

  for (const option of AUTHENTICATED_ROUTE_OPTIONS) {
    if (satisfiesAnyRoutePrivilegeForUser(userPrivs, option.requiredPrivileges)) {
      return option.path;
    }
  }

  return FALLBACK_AUTHENTICATED_ROUTE;
}
